module.exports = "<div class=\"section center row\">\n  <my-button my-label=\"$root.labels.back\"\n    my-icon=\"$root.icons.back\"\n    tabindex=\"-1\"\n    my-click=\"$root.$back()\"\n    my-style=\"$root.styles.dark()\">\n  </my-button>\n\n  <my-button my-label=\"myLabel || label\"\n    my-icon=\"myIcon || icon\"\n    my-type=\"'submit'\"\n    my-click=\"myClick()\"\n    my-disabled=\"myDisabled\">\n  </my-button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/global/directives/buttons/myCancelValidateButtons.html
// module id = 1206
// module chunks = 0